import React, { useState, useEffect } from 'react';
import { TEXT_FIELDS, fetchSiteTexts, updateSiteText } from '../../lib/texts';

const TextField = ({ field, value, onSaved }) => {
  const [val, setVal] = useState(value);
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState('');

  useEffect(() => {
    setVal(value);
  }, [value]);

  const save = async () => {
    setBusy(true);
    setStatus('');
    try {
      await updateSiteText(field.key, val);
      setStatus('✓ Sparat');
      onSaved(field.key, val);
    } catch (err) {
      setStatus('Fel: ' + err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bg-cv-base border border-cv-border flex flex-col gap-2" style={{ borderRadius: 'var(--cv-radius)', padding: 20 }}>
      <label className="text-sm font-medium text-cv-ink">{field.label}</label>
      {field.multiline ? (
        <textarea value={val} onChange={(e) => setVal(e.target.value)} rows={4} className="px-3 py-2.5 bg-cv-base border border-cv-edge rounded-cv text-cv-ink outline-none focus:border-cv-accent resize-y" />
      ) : (
        <input value={val} onChange={(e) => setVal(e.target.value)} className="px-3 py-2.5 bg-cv-base border border-cv-edge rounded-cv text-cv-ink outline-none focus:border-cv-accent" />
      )}
      <div className="flex items-center gap-3">
        {val !== value && (
          <button type="button" onClick={save} disabled={busy} className="w-fit bg-cv-ink text-cv-base border-none px-5 py-2 text-xs tracking-[0.12em] uppercase rounded-cv cursor-pointer hover:bg-cv-ink2 transition-colors disabled:opacity-60">
            Spara
          </button>
        )}
        {status && <span className="text-xs text-cv-ink2">{status}</span>}
      </div>
    </div>
  );
};

export const TextsManager = () => {
  const [texts, setTexts] = useState(null);

  useEffect(() => {
    fetchSiteTexts().then(setTexts);
  }, []);

  const onSaved = (key, value) => setTexts((t) => ({ ...t, [key]: value }));

  return (
    <div className="flex flex-col gap-6">
      <div className="bg-cv-panel border border-cv-border" style={{ borderRadius: 'var(--cv-radius)', padding: 20 }}>
        <p className="m-0 text-sm text-cv-muted leading-[1.7]">
          Här kan du ändra texterna på startsidan och sidan Om mig. Skriv om texten och klicka <strong>Spara</strong> –
          ändringen syns direkt på hemsidan.
        </p>
      </div>
      {!texts ? (
        <p className="text-cv-muted">Laddar texter…</p>
      ) : (
        <div className="flex flex-col gap-4">
          {TEXT_FIELDS.map((f) => (
            <TextField key={f.key} field={f} value={texts[f.key] || ''} onSaved={onSaved} />
          ))}
        </div>
      )}
    </div>
  );
};
